import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { ILanguage } from '../../models/language.model';
import { UiState } from '../../state/ui.state';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  standalone: false,
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  languageValue: string;
  languageSource: string;
  private subscriptions = new Subscription();

  languages: ILanguage[] = [
    {
      label: 'English',
      value: 'en',
      iconSource: 'assets/images/languageIcons/united-kingdom-flag-round-large.png',
    },
    { label: 'Norsk', value: 'no', iconSource: 'assets/images/languageIcons/norway.png' },
    { label: 'Svenska', value: 'se', iconSource: 'assets/images/languageIcons/sweden.png' },
    { label: 'Íslenska', value: 'is', iconSource: 'assets/images/languageIcons/iceland.png' },
    {
      label: 'Nederlands',
      value: 'nl',
      iconSource: 'assets/images/languageIcons/netherlands.svg',
    },
  ];

  constructor(
    private languageService: LanguageService,
    private store: Store
  ) {}

  ngOnInit(): void {
    // Initialize with current language from localStorage as fallback
    const currentLanguage = this.languageService.getCurrentLanguage();
    this.languageValue = currentLanguage;
    this.setLanguageSource();

    this.subscriptions.add(
      this.store.select(UiState.language).subscribe((language) => {
        if (language) {
          this.languageValue = language;
          this.setLanguageSource();
        }
      })
    );
  }

  setLanguage = (language: string) => {
    this.languageService.setLanguage(language);
  };

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private setLanguageSource(): void {
    this.languageSource =
      this.languages.find((lang: ILanguage) => lang.value === this.languageValue)?.iconSource ?? '';
  }
}
